import React from "react";
import { Box } from '@mui/joy';
import { Pie, Table, Timeline } from 'src/mtska-frontend-app-component';
import { useTranslation } from 'react-i18next';
import { Filters, Overview } from ".";
import KPISet from "./KPISet";
import useFiltersFromLocation from "src/mtska-frontend-app-scaffolding/hooks/useFiltersFromLocation";
import { useDataProvider } from "src/mtska-frontend-data-provider";
import { useNavigate } from 'react-router-dom';

const RunningDashboard = React.forwardRef((props, ref) => {

    const showKPI = true;
    const showPIEFleet = true;
    const showPIEAccounting = true;
    const showPIEExpiration = true;
    const showPIETraceKm = true;
    const showPIEPurchase = true;
    const showPIEPotential = true;
    const showOverviewByRenter = true;
    const showOverviewByArea = true;
    const showOverviewByAccount = true;
    const showOverviewByCustomerCluster = true;
    const showTimelineExpiration = true;
    const showTimelineCommission = true;
    const showActionablesExpiration = true;
    const showActionablesKm = true;

    const { item: user } = useDataProvider('auth/token');

    const { t } = useTranslation();
    const navigate = useNavigate()

    const [filters, setFilters] = useFiltersFromLocation();

    function handleFilterChange(field, newValue) {
        setFilters(prevFilters => {

            const items = Array.isArray(prevFilters?.items) ? [...prevFilters.items] : [];
            const index = items.findIndex(item => item.field === field);

            if (index !== -1) {
                items[index] = { ...items[index], value: newValue };
            } else {
                items.push({
                    field,
                    operator: "equals",
                    value: newValue
                });
            }

            // console.info('RunningDashboard handleFilterChange', {
            //     ...prevFilters,
            //     items
            // });

            return {
                ...prevFilters,
                items
            };
        });
    }

    const createRenderCell = (field, handleFilterChange) => (params) => (
        <span
            onClick={(e) => {
                e.stopPropagation();
                handleFilterChange(field, params.value);
            }}
            style={{ cursor: 'pointer', color: 'var(--app-menu-background-flat-text)' }}
        >
            {params.value}
        </span>
    );

    const createSliceFilterHandler = (field, handleFilterChange) => (params) => {

        const detranslation = {
            "In marcia":"running",
            "In fase d'ordine":"in_order",
            "Archiviato":"closed"
        }
        handleFilterChange(field, detranslation[params] ?? params);
    };

    const createTimelineBarFilterHandler = () => (params) => {
        const monthNames = [
            "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
            "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"
        ];

        const [monthStr, yearStr] = params.toLowerCase().split(' ');
        const month = monthNames.indexOf(monthStr);
        const year = parseInt(yearStr, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        console.info(end.toISOString())

        const yearStart = start.getFullYear();
        const monthStart = String(start.getMonth() + 1).padStart(2, '0');
        const dayStart = String(start.getDate()).padStart(2, '0');

        const yearEnd = end.getFullYear();
        const monthEnd = String(end.getMonth() + 1).padStart(2, '0');
        const dayEnd = String(end.getDate()).padStart(2, '0');

        let localfilters = {
            items: [
                ...(filters?.items || []),
                {
                    field: "_related_contract_end_at",
                    operator: "between",
                    value: { from: `${yearStart}-${monthStart}-${dayStart}T00:00:00.000Z`, to: `${yearEnd}-${monthEnd}-${dayEnd}T23:58:59.000Z` }
                }
            ]
        }

        const qs = localfilters.items.map(f => {
            const value = typeof f.value === 'object'
                ? encodeURIComponent(JSON.stringify(f.value))
                : encodeURIComponent(f.value);
            return `${encodeURIComponent(f.field)}=${value}`;
        }).join('&');

        navigate('/cars/car?' + qs);
    };

    const getTransposedDateFirstOfMonth = (months) => {
        const today = new Date();
        const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        firstOfMonth.setMonth(firstOfMonth.getMonth() + months);

        const yyyy = firstOfMonth.getFullYear();
        const mm = String(firstOfMonth.getMonth() + 1).padStart(2, '0');
        const dd = String(firstOfMonth.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
    }

    return (
        <Box ref={ref}>
            <Filters filters={filters} setFilters={setFilters} />

            {showKPI &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-kpi">
                    <KPISet filters={filters} />
                </Box>
            }

            {showOverviewByRenter &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByRenter'
                        aggregatorLabel={t('renter')}
                        aggregateBy='_related_renter_name'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_renter_name', handleFilterChange)}
                    />
                </Box>
            }

            {showOverviewByCustomerCluster &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByCustomerCluster'
                        aggregatorLabel={t('Profilazione Cliente')}
                        aggregateBy='_related_legalEntity_commercialCluster'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_legalEntity_commercialCluster', handleFilterChange)}
                    />
                </Box>
            }

            {showOverviewByArea && !user?.data?.roles?.includes('Account') && !user?.data?.roles?.includes('Area manager') &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByArea'
                        aggregatorLabel={t('Area commerciale')}
                        aggregateBy='_related_account_area_name'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_account_area_name', handleFilterChange)}
                    />
                </Box>
            }

            {showOverviewByAccount && !user?.data?.roles?.includes('Account') && !user?.data?.roles?.includes('Executive') &&
                <Box className="dashboard-menu-itemgroup  dashboard-menu-itemgroup-overview" sx={{ marginTop: '30px' }}>
                    <Overview
                        dataProviderName='statisticsviews/fleet/overviewByAccount'
                        aggregatorLabel={t('Azienda proprietario')}
                        aggregateBy='_related_account_name'
                        filters={filters}
                        legalEntityClickHandler={createRenderCell('_related_account_name', handleFilterChange)}
                    />
                </Box>
            }

            {showPIEFleet &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                    {!user?.data?.roles?.includes('Area manager') &&
                        <Box className="dashboard-menu-item">
                            <Pie
                                title={t("Distribuzione per Rete Commerciale")}
                                dataProviderName={"statisticsviews/fleetbyarea/aggregated/views_cars_car/_related_account_area_name"}
                                filters={{
                                    items: [
                                        ...(filters?.items || [])
                                    ]
                                }}
                                handleFilterChange={createSliceFilterHandler('_related_account_area_name', handleFilterChange)}
                            />
                        </Box>
                    }
                    {!user?.data?.roles?.includes('Area manager') &&
                        <Box className="dashboard-menu-item">
                            <Pie
                                title={t("Distribuzione per Area Commerciale")}
                                dataProviderName={"statisticsviews/fleetbyaccount/aggregated/views_cars_car/_related_account_shop_name"}
                                filters={{
                                    items: [
                                        ...(filters?.items || [])
                                    ]
                                }}
                                handleFilterChange={createSliceFilterHandler('_related_account_shop_name', handleFilterChange)}
                            />
                        </Box>
                    }
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={"Distribuzione per Profilazione Cliente"}
                            dataProviderName={"statisticsviews/fleetbycustomer/aggregated/views_cars_car/_related_legalEntity_commercialCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            handleFilterChange={createSliceFilterHandler('_related_legalEntity_commercialCluster', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={"Distribuzione per Noleggiatore"}
                            dataProviderName={"statisticsviews/fleetbyrenter/aggregated/views_cars_car/_related_renter_name"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            handleFilterChange={createSliceFilterHandler('_related_renter_name', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }

            {showPIEAccounting && !user?.data?.roles?.includes('Account') &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={"Distribuzione per Stato Veicolo"}
                            dataProviderName={"statisticsviews/fleetbystatus/aggregated/views_cars_car/status"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            handleFilterChange={createSliceFilterHandler('status', handleFilterChange)}
                        />
                    </Box>

                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Distribuzione per Azienda Proprietario")}
                            dataProviderName={"statisticsviews/fleetbyaccount/aggregated/views_cars_car/_related_account_name"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            handleFilterChange={createSliceFilterHandler('_related_account_name', handleFilterChange)}
                        />
                    </Box>

                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Distribuzione per Marca")}
                            dataProviderName={"statisticsviews/fleetbymake/aggregated/views_cars_car/_related_setup_make"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                        />
                    </Box>

                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Distribuzione per Cliente")}
                            dataProviderName={"statisticsviews/fleetbymake/aggregated/views_cars_car/_related_legalEntity_name"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                        />
                    </Box>
                </Box>
            }

            {showPIEExpiration &&
                <Box className="dashboard-section-title">
                    <h2>{t('Distribuzione vetture in scadenza per tipologia cliente')}</h2>
                </Box>
            }

            {showPIEExpiration &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Tutte le vetture")}<br></br>{t("in scadenza")}</>}
                            dataProviderName={"statisticsviews/fleetbyexpiration_general/expirationaggregate"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti VIP")}</>}
                            dataProviderName={"statisticsviews/fleetbyexpiration_vip/expirationaggregate"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "VIP (OVER 50)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti TOP")}</>}
                            dataProviderName={"statisticsviews/fleetbyexpiration_top/expirationaggregate"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "TOP (21-50)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti MEDIUM")}</>}
                            dataProviderName={"statisticsviews/fleetbyexpiration_medium/expirationaggregate"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "MEDIUM (6-20)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti SMALL")}</>}
                            dataProviderName={"statisticsviews/fleetbyexpiration_small/expirationaggregate"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "SMALL (2-5)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Vetture in scadenza")}<br></br>{t("Clienti SINGLE")}</>}
                            dataProviderName={"statisticsviews/fleetbyexpiration_single/expirationaggregate"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "SINGLE (1)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }


            {showPIETraceKm &&
                <Box className="dashboard-section-title">
                    <h2>{t('Rilevamento KM per tipologia cliente')}</h2>
                </Box>
            }

            {showPIETraceKm &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Tutte i rilevamenti")}<br></br>{t("kilometrici")}</>}
                            dataProviderName={"statisticsviews/fleetbykm_general/aggregated/views_cars_car/traceKmsCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Rilevamento KM")}<br></br>{t("Clienti VIP")}</>}
                            dataProviderName={"statisticsviews/fleetbykm_vip/aggregated/views_cars_car/traceKmsCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "VIP (OVER 50)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Rilevamento KM")}<br></br>{t("Clienti TOP")}</>}
                            dataProviderName={"statisticsviews/fleetbykm_top/aggregated/views_cars_car/traceKmsCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "TOP (21-50)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Rilevamento KM")}<br></br>{t("Clienti MEDIUM")}</>}
                            dataProviderName={"statisticsviews/fleetbykm_medium/aggregated/views_cars_car/traceKmsCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "MEDIUM (6-20)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Rilevamento KM")}<br></br>{t("Clienti SMALL")}</>}
                            dataProviderName={"statisticsviews/fleetbykm_small/aggregated/views_cars_car/traceKmsCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "SMALL (2-5)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={<>{t("Rilevamento KM")}<br></br>{t("Clienti SINGLE")}</>}
                            dataProviderName={"statisticsviews/fleetbykm_single/aggregated/views_cars_car/traceKmsCluster"}
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_legalEntity_commercialCluster",
                                        operator: "equals",
                                        value: "SINGLE (1)"
                                    }
                                ]
                            }}
                            monochrome={{
                                enabled: true,
                                color: '#52b5f1',
                                shadeTo: 'dark',
                                shadeIntensity: 1
                            }}
                            width={150}
                            height={150}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }

            {showPIEPotential &&
                <Box className="bigBlackFuckingBox" style={{marginTop:'40px'}}>
                    <Box className="dashboard-section-title">
                        <h2>{t('Potenziale flotta aggredibile per tipologia cliente')}</h2>
                    </Box>
                    <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                        {/* <Box className="dashboard-menu-item">
                            <Pie
                                title={<>{t("Potenziale generale")}<br></br>{t("TOTALE")}</>}
                                dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                                filters={{
                                    items: [
                                        ...(filters?.items || [])
                                    ]
                                }}
                                monochrome={{
                                    enabled: true,
                                    color: '#52b5f1',
                                    shadeTo: 'dark',
                                    shadeIntensity: 1
                                }}
                                width={200}
                                height={200}
                            //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                            />
                        </Box> */}
                        <Box className="dashboard-menu-item">
                            <Pie
                                title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti VIP")}</>}
                                dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                                filters={{
                                    items: [
                                        ...(filters?.items || []),
                                        {
                                            field: "_related_legalEntity_commercialCluster",
                                            operator: "equals",
                                            value: "VIP (OVER 50)"
                                        }
                                    ]
                                }}
                                monochrome={{
                                    enabled: true,
                                    color: '#52b5f1',
                                    shadeTo: 'dark',
                                    shadeIntensity: 1
                                }}
                                width={200}
                                height={200}
                            //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                            />
                        </Box>
                        <Box className="dashboard-menu-item">
                            <Pie
                                title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti TOP")}</>}
                                dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                                filters={{
                                    items: [
                                        ...(filters?.items || []),
                                        {
                                            field: "_related_legalEntity_commercialCluster",
                                            operator: "equals",
                                            value: "TOP (21-50)"
                                        }
                                    ]
                                }}
                                monochrome={{
                                    enabled: true,
                                    color: '#52b5f1',
                                    shadeTo: 'dark',
                                    shadeIntensity: 1
                                }}
                                width={200}
                                height={200}
                            //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                            />
                        </Box>

                        <Box className="dashboard-menu-item">
                            <Pie
                                title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti MEDIUM")}</>}
                                dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                                filters={{
                                    items: [
                                        ...(filters?.items || []),
                                        {
                                            field: "_related_legalEntity_commercialCluster",
                                            operator: "equals",
                                            value: "MEDIUM (6-20)"
                                        }
                                    ]
                                }}
                                monochrome={{
                                    enabled: true,
                                    color: '#52b5f1',
                                    shadeTo: 'dark',
                                    shadeIntensity: 1
                                }}
                                width={200}
                                height={200}
                            //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                            />
                        </Box>
                        <Box className="dashboard-menu-item">
                            <Pie
                                title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti SMALL")}</>}
                                dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                                filters={{
                                    items: [
                                        ...(filters?.items || []),
                                        {
                                            field: "_related_legalEntity_commercialCluster",
                                            operator: "equals",
                                            value: "SMALL (2-5)"
                                        }
                                    ]
                                }}
                                monochrome={{
                                    enabled: true,
                                    color: '#52b5f1',
                                    shadeTo: 'dark',
                                    shadeIntensity: 1
                                }}
                                width={200}
                                height={200}
                            //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                            />
                        </Box>
                    </Box>
                </Box>
            }

            {showPIEPurchase && false &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Fleet by Purchase Type")}
                            dataProviderName={"statisticsviews/fleetbypurchasetype/aggregated/views_cars_car/_related_contract_orderPurchaseType"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Fleet by Order Type")}
                            dataProviderName={"statisticsviews/fleetbyordertype/aggregated/views_cars_car/_related_contract_orderType"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderType', handleFilterChange)}
                        />
                    </Box>
                    <Box className="dashboard-menu-item">
                        <Pie
                            title={t("Fleet by Extension Type")}
                            dataProviderName={"statisticsviews/fleetbyextensiontype/aggregated/views_cars_car/_related_contract_orderExtensionType"}
                            filters={{
                                items: [
                                    ...(filters?.items || [])
                                ]
                            }}
                        //handleFilterChange={createSliceFilterHandler('_related_contract_orderExtensionType', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }


            {showTimelineExpiration &&
                <Box className="dashboard-section-title">
                    <h2>{"Calendario Scadenze"}</h2>
                </Box>
            }
            {showTimelineExpiration &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-timeline" sx={{ marginTop: '10px' }}>
                    <Box className="dashboard-menu-item">
                        <Timeline
                            dataProviderName="statisticsviews/fleetbytimelinedexpiration/timelined/views_cars_car/_related_contract_end_at/month"
                            //format="currency"
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_contract_end_at",
                                        operator: "between",
                                        value: {
                                            from: getTransposedDateFirstOfMonth(0),
                                            to: getTransposedDateFirstOfMonth(11),
                                        }
                                    }
                                ]
                            }}
                            handleFilterChange={createTimelineBarFilterHandler('_related_contract_end_at', handleFilterChange)}
                        />
                    </Box>
                </Box>
            }

            {showTimelineCommission && false &&
                <Box className="dashboard-section-title">
                    <h2>{t('Commission calendar')}</h2>
                </Box>
            }
            {showTimelineCommission && false &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-timeline" sx={{ marginTop: '10px' }}>
                    <Box className="dashboard-menu-item">
                        <Timeline
                            title={t("Commission calendar")}
                            dataProviderName="statisticsviews/fleetbytimelinedexpiration/timelined/views_cars_car/_related_contract_start_at/month/_related_contract_commission"
                            format="currency"
                            filters={{
                                items: [
                                    ...(filters?.items || []),
                                    {
                                        field: "_related_contract_start_at",
                                        operator: "after",
                                        value: getTransposedDateFirstOfMonth(0)
                                    }
                                ]
                            }}
                        />
                    </Box>
                </Box>
            }

            {showActionablesExpiration &&
                <Box className="dashboard-section-title">
                    <h2>{t('Vetture in scadenza')}</h2>
                </Box>
            }
            {showActionablesExpiration &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-table">
                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            dataProviderName={'statisticsviews/cars/contractExpiringYear'}
                            filters={filters}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_renter_name', headerName: t('renter'), flex: 1,
                                    //renderCell: createRenderCell('_related_renter_name', handleFilterChange),
                                },
                                { field: '_related_contract_end_at', headerName: t('end_at'), flex: 1, "type": "date", valueGetter: (params) => params ? new Date(params) : null },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?status=running&_related_contract_end_at=' + JSON.stringify({ from: getTransposedDateFirstOfMonth(0), to: getTransposedDateFirstOfMonth(12) })}
                        />
                    </Box>
                </Box>
            }
            {showActionablesKm &&
                <Box className="dashboard-section-title">
                    <h2>{t('Rilevamenti chilometrici')}</h2>
                </Box>
            }
            {showActionablesKm &&
                <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-table" sx={{ marginTop: '30px' }}>

                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            title={t("Rilevamenti KM mancanti")}
                            dataProviderName={'statisticsviews/cars/missingKms'}
                            filters={{
                                items: [
                                    ...(filters?.items?.filter(item => item.field !== "projectedDeltaMileage") || []),
                                    {
                                        field: "projectedDeltaMileage",
                                        operator: "isEmpty",
                                        value: '_'
                                    }
                                ]
                            }}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                {
                                    field: '_related_renter_name', headerName: t('renter'), flex: 1,
                                    //renderCell: createRenderCell('_related_renter_name', handleFilterChange),
                                },
                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?projectedDeltaMileage=missing'}
                        />
                    </Box>

                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            title={"Rilevamenti KM in eccesso"}
                            dataProviderName={'statisticsviews/cars/exceedingKms'}
                            filters={{
                                items: [
                                    ...(filters?.items?.filter(item => item.field !== "projectedDeltaMileage") || []),
                                    {
                                        field: "projectedDeltaMileage",
                                        operator: ">",
                                        value: 1001
                                    }
                                ]
                            }}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                { field: 'projectedDeltaMileagePercentage', headerName: t('% scostamento'), flex: 1, valueGetter: (params) => params ? params + '%' : null },
                                { field: 'traceKmsLast_at_readable', headerName: t('Data ultima rilevazione'), flex: 1, "type": "date", valueGetter: (params) => params ? new Date(params) : null },

                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?projectedDeltaMileage=' + JSON.stringify({ from: 1001, to: 1000000 })}
                        />
                    </Box>

                    <Box className="dashboard-menu-item dashboard-menu-item-tablewrapper autoheight">
                        <Table
                            title={t("Rilevamenti KM in difetto")}
                            dataProviderName={'statisticsviews/cars/tooFewKms'}
                            filters={{
                                items: [
                                    ...(filters?.items?.filter(item => item.field !== "projectedDeltaMileage") || []),
                                    {
                                        field: "projectedDeltaMileage",
                                        operator: "<",
                                        value: -1001
                                    }
                                ]
                            }}
                            columns={[
                                { field: 'plate', headerName: t('plate'), width: 150 },
                                {
                                    field: '_related_legalEntity_name', headerName: t('customer'), flex: 1,
                                    //renderCell: createRenderCell('_related_legalEntity_name', handleFilterChange),
                                },
                                { field: 'projectedDeltaMileagePercentage', headerName: t('% scostamento'), flex: 1, valueGetter: (params) => params ? params + '%' : null },
                                { field: 'traceKmsLast_at_readable', headerName: t('Data ultima rilevazione'), flex: 1, "type": "date", valueGetter: (params) => params ? new Date(params) : null },

                                ...(!user?.data?.roles?.includes('Account')
                                    ? [{ field: '_related_account_name', headerName: t('Azienda proprietario'), flex: 1 }]
                                    : [])
                            ]}
                            drawerRouteBase='cars'
                            showAllRoute={'/cars/car?projectedDeltaMileage=' + JSON.stringify({ from: -1000000, to: -1001 })}
                        />
                    </Box>
                </Box>
            }
        </Box>
    )
})

export default RunningDashboard;
